<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized && !existingRegistration" class="container mb-5 space-1 mt-5">
  <div class="w-md-80 w-lg-50 text-center mx-md-auto">

    <div class="mb-5">
      <h1 class="h3 font-weight-medium">No Registration to modify</h1>
      <p>You are not currently registered for this conference. If you think this is in error, please log in with a different email and try again.</p>
    </div>
    <a class="btn btn-primary btn-pill transition-3d-hover px-5" [routerLink]="['../../']">Conference Homepage</a>
  </div>
</div>
<div *ngIf="initialized && existingRegistration" class="container mb-5">

  <form #theForm="ngForm" novalidate>
    <div class="modal-body">
      <div class="form-group text-center">
        <h3 class="h4 mb-0">Modify Registration</h3>
        <h6 class="text-center register-event-title">{{existingRegistration.package.category}} > {{ existingRegistration.package.name }}</h6>
        <h4>{{ actualPrice | currency: existingRegistration.package.currencyCode:'symbol' }}</h4>
      </div>
      <div *ngIf="errorMessage" class="alert alert-primary" role="alert">
        {{ errorMessage }}
      </div>
      <div *ngIf="(existingRegistration.package.ceUsAreExtra && existingRegistration.paidForCEUs) || purchasedAddons.length > 0 || purchasedEventAddons.length > 0" class="mb-4">
        <div>
          You registration currently includes:
        </div>
        <div *ngIf="existingRegistration.package.ceUsAreExtra && existingRegistration.paidForCEUs" class="col-12">
          <span class="text-success mr-1"><i class="fas fa-check-circle"></i></span>Paid for CEUs
        </div>
        <div *ngFor="let addon of purchasedAddons" class="col-12">
          {{ addon.name }}
        </div>
        <div *ngFor="let eventAddon of purchasedEventAddons" class="col-12">
          {{ eventAddon.title }}
        </div>
      </div>
      <div class="alert alert-warning">You are already registered for this conference. Please use the form below to make changes to your registration. You can add workshops, CEUs or reserve breakouts.</div>
      <div class="form-row">
        <div *ngIf="existingRegistration.package.ceUsAreExtra && !existingRegistration.paidForCEUs" class="col-md-6 mb-2">
          <label for="uname1"> Would you like to add CEUs to your registration?</label>
          <select class="form-control" (change)="calculatePrice()" [(ngModel)]="model.purchaseCEUs" required name="purchaseCEUs">
            <option [ngValue]="null">Please choose....</option>
            <option [ngValue]="true">Yes (+{{ (existingRegistration.memberRate ? existingRegistration.package.ceuPrice : existingRegistration.package.ceuNonMemberPrice == null ? existingRegistration.package.ceuPrice : existingRegistration.package.ceuNonMemberPrice) | currency: existingRegistration.package.currencyCode:'symbol' }})</option>
            <option [ngValue]="false">No</option>
          </select>
          <div class="invalid-message">
            <div>Please indicate if you want CEUs.</div>
          </div>
        </div>
      </div>
      <div *ngIf="addons.length > 0" class="form-row">
        <div class="col-md-12 mb-3">
          <div class="d-block"><strong>Would you like to add any add-ons to your registration?</strong></div>

          <!-- Checkbox Switch -->
          <ng-container *ngFor="let addon of addons; let i = index">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" (change)="calculatePrice()" [(ngModel)]="addon.selected" name="addons{{ i }}" id="customSwitch{{ i }}" />
              <label class="custom-control-label" for="customSwitch{{ i }}">
                <span class="d-block"
                  >{{ addon.name }} <span *ngIf="addon.price > 0">(+{{ addon.price | currency: existingRegistration.package.currencyCode }})</span><span *ngIf="addon.price == 0">(FREE)</span></span
                >
                <small class="d-block text-muted">{{ addon.description }}</small>
              </label>
            </div>
            <!-- End Checkbox Switch -->

            <hr class="my-2" />
          </ng-container>
        </div>
      </div>
      <div *ngIf="eventAddons.length > 0" class="form-row">
        <div class="col-md-12 mb-3">
          <div class="d-block"><strong>Would you like to add any workshops to your registration?</strong></div>

          <!-- Checkbox Switch -->
          <ng-container *ngFor="let addon of eventAddons; let i = index">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" (change)="calculatePrice()" [(ngModel)]="addon.selected" name="eventAddons{{ i }}" id="customEventSwitch{{ i }}" />
              <label class="custom-control-label" for="customEventSwitch{{ i }}">
                <span *ngIf="!addon.memberPricing || !existingRegistration.memberRate" class="d-block">{{ addon.formattedStartTime }} {{ addon.title }} (+{{ addon.price | currency: existingRegistration.package.currencyCode:'symbol' }})</span>
                <span *ngIf="addon.memberPricing && existingRegistration.memberRate" class="d-block">{{ addon.formattedStartTime }} {{ addon.title }} (+{{ addon.memberPrice | currency: existingRegistration.package.currencyCode:'symbol' }})</span>
                <small class="d-block text-muted">{{ addon.instructor.fullNameWithCredentials }}</small>
              </label>
            </div>
            <!-- End Checkbox Switch -->

            <hr class="my-2" />
          </ng-container>
        </div>
      </div>
      <div *ngIf="existingRegistration.package.reserveBreakouts && startTimes.length > 0" class="form-row">
        <div class="col-md-12 mb-3">
          <div class="d-block"><strong>Reserve Breakouts:</strong></div>
          <div class="d-block"><small> Please select one breakout session at each time slot below for a total of six selections. Please note, there is a scroll on each session for a total of (14) choices at each time. All other conference sessions (with the exception of workshops) are pre-selected and included.</small></div>
          <div class="d-block"><small> Breakouts are targeted to all experience levels unless otherwise noted in the description.</small></div>

          <!-- Checkbox Switch -->
          <div class="mb-2" *ngFor="let addon of startTimes; let i = index">
            <label for="uname1">{{ addon.key() }}</label>
            <event-picker class="form-control" required [data]="addon.getSource()" [valuePrimitive]="true" [(ngModel)]="reservedBreakouts[i]" name="reservedBreakout{{ i }}" textField="title" valueField="id"></event-picker>

            <!-- <kendo-combobox class="form-control" [valuePrimitive]="true" required [data]="addon.getSource()" [(ngModel)]="reservedBreakouts[i]" name="reservedBreakout{{ i }}" textField="title" valueField="id">
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <div class="d-flex">
                  <div class="ml-1 flex-grow">
                    <div class="d-block mb-0">{{ dataItem.title }}</div>
                    <div class="d-block text-admin-primary font-weight-semi-bold mb-0">{{ dataItem.instructorName }} + ({{ dataItem.totalCEUs }} CEU)</div>
                    <span class="paper-tag" *ngFor="let tag of dataItem.tags">{{ tag }}</span>
                    <hr class="mb-1 d-block mt-1" />
                  </div>
                </div>
              </ng-template>
            </kendo-combobox> -->
            <!-- <select class="form-control" [(ngModel)]="tShirtSize" name="tShirtSize" required>
              <option *ngFor="let evt of addon.getSource()" value="{{ evt.id }}">{{ evt.title + ' (' + evt.totalCEUs + ' CEU)' }}</option>
            </select> -->
            <div class="invalid-message">
              <div>This breakout is required</div>
            </div>
            <!-- End Checkbox Switch -->
          </div>
        </div>
      </div>

      <div *ngIf="actualPrice > 0" class="form-row">
        <div class="col-md-6 mb-2">
          <label for="uname1">Card Number</label>
          <input type="text" class="form-control" [(ngModel)]="cardNumber" name="cardNumber" required creditcard placeholder="Card Number" />
          <div class="invalid-message">
            <div>Card Number is required</div>
          </div>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4 mb-2">
          <label for="uname1">Month</label>
          <select class="form-control" [(ngModel)]="expMo" name="expMo" required>
            <option value="1">01 - January</option>
            <option value="2">02 - February</option>
            <option value="3">03 - March</option>
            <option value="4">04 - April</option>
            <option value="5">05 - May</option>
            <option value="6">06 - June</option>
            <option value="7">07 - July</option>
            <option value="8">08 - August</option>
            <option value="9">09 - September</option>
            <option value="10">10 - October</option>
            <option value="11">11 - November</option>
            <option value="12">12 - December</option>
          </select>
          <div class="invalid-message">
            <div>Month is required</div>
          </div>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4 mb-2">
          <label for="uname1">Year</label>
          <select class="form-control" [(ngModel)]="expYr" name="expYr" required>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
            <option value="2030">2030</option>
            <option value="2031">2031</option>
            <option value="2032">2032</option>
            <option value="2033">2033</option>
            <option value="2034">2034</option>
          </select>
          <div class="invalid-message">
            <div>Year is required</div>
          </div>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4 mb-2">
          <label for="uname1">CVV</label>
          <input type="text" class="form-control" [(ngModel)]="cvv" name="cvv" placeholder="CVV" required />
          <div class="invalid-message">
            <div>CVV is required</div>
          </div>
        </div>
      </div>

      <div *ngIf="errorMessage" class="alert alert-primary mt-2" role="alert">
        {{ errorMessage }}
      </div>
      <div class="form-group text-center mt-3">
        <button type="button" class="btn btn-primary btn-block" data-dismiss="modal" aria-hidden="true" [promiseBtn]="submitComplete" (click)="purchasePackageClicked()">Modify Registration - {{ actualPrice | currency: existingRegistration.package.currencyCode:'symbol' }}</button>
      </div>
    </div>
  </form>
</div>
